import React, { Component } from 'react'
import ReactModal from 'react-modal'
import ReactTooltip from 'react-tooltip'
import classnames from 'classnames'

import Button from './UI/Button'

class ModalAlertDialog extends Component {
  okButton = React.createRef();
  cancelButton = React.createRef();

  handleCloseModal = () => {
    // close modal
  };

  afterOpenModal = () => {
    ReactTooltip.rebuild();
  };

  handleButtonClick(type, id) {
    switch (type) {
      case "ok":
        this.props.parentCallback('ok');
        break;
      case "cancel":
        this.props.parentCallback("cancel");
        break;

      default:
        break;
    }
    // modal closes from parent
  }

  handleEnterPressed = (e) => {
    if (e.key === "Enter") {
      this.okButton.current.click();
    } else if(e.key === "Esc") {
      this.cancelButton.current.click();
    }
  };

  render() {
    const {
      open,
      message
    } = this.props;

    return (
      <ReactModal
        isOpen={open}
        onAfterOpen={this.afterOpenModal}
        onRequestClose={this.handleCloseModal}
        shouldCloseOnOverlayClick={false}
        className="react-modal alert"
        overlayClassName="react-modal-overlay"
        contentLabel="Alert"
      >
        <div className={classnames("alert-panel")}>
          <p>{message}</p>
          <div className={classnames("alert-buttons")}>
            <Button
              name="Cancel"
              onClick={() => this.handleButtonClick("cancel")}
            />
            <Button
              name="OK"
              onClick={() => this.handleButtonClick("ok")}
            />
          </div>
        </div>
      </ReactModal>
    );
  }
}

export default ModalAlertDialog;
